import React from "react";
import '../../../styles/education.css';
import SchoolImage from '../../../assets/images/school.svg';

const Education=()=>{
    return(
        <div className="educationContainer">
        <h3 className="educationTitle">EDUCATION</h3>
        <div className="education">
        <div className="educationDetails">
          <ul className="listVerticalEdu">
            <li className="innerListEdu"></li>
            <li className="innerListEdu"></li>
            <li className="innerListEdu"></li>
          </ul>
          <ul className="educationAnswer">
            <li>
              <div>
                <h4>SBM College of Engineering and Technology</h4>
                <p className="date">2019 - 2023</p>
              </div>
              <p className="degree">Computer Science and Engineering</p>
            </li>
            <li>
              <div>
                <h4>Government Higher Secondary School</h4>
                <p className="date">2018 - 2019</p>
              </div>
              <p className="degree">HSC</p>
            </li>
            <li>
              <div>
                <h4>Government Higher Secondary School</h4>
                <p className="date">2016 - 2017</p>
              </div>
              <p className="degree">SSLC</p>
            </li>
          </ul>
        </div>
        <img src={SchoolImage} alt="School Logo"/>
      </div>
      
      </div>
    )
}

export default Education;